const tournamentConfig = {
  updateInterval: 50000,
  spinAndGoUpdateInterval: 30000,
};

export default tournamentConfig;
